<template>
    <div class="page-content">
        <div class="container has-text-left">
            <div class="hero is-medium">
                <div class="hero-body">
                    <h1 class="title is-1 has-text-grey">404</h1>
                    <h2 class="title is-3 has-text-grey">Hier ist ein Fehler aufgetreten.</h2>
                    <p class="title is-3 has-text-grey">{{ errorMessage }}</p>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="section">
                <a @click="goToStart()" class="is-size-3">Zurück zur Startseite</a>
            </div>
        </div>
    </div>
</template>

<script>

import {mapGetters} from "vuex";

export default {
    name: "ErrorPage",
    computed: {
        ...mapGetters(['httpStatusCode']),
        errorMessage() {
            let statusType = this.httpStatusCode.toString().substring(0, 1);
            switch (statusType) {
                case '4':
                    return 'Diese Seite wurde verschoben oder ist nicht mehr verfügbar.';
                case '5':
                    return 'Der Server konnte Ihre Anfrage leider nicht verarbeiten. Bitte versuchen Sie es zu einem späteren Zeitpunkt erneut';
                default:
                    return 'Diese Seite wurde verschoben oder ist nicht mehr verfügbar.';

            }
        }
    },
    methods: {
        goToStart() {
            this.$router.push('/');
        },
        fetchCMSData() {
            this.$store.dispatch('fetchCMSPage', {urlSlug: "/"});
        },
    },
    created() {
        this.fetchCMSData();
    },
}
</script>

<style scoped>

</style>